import script from "./MainCrumb.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainCrumb.vue?vue&type=script&setup=true&lang=ts"

import "./MainCrumb.vue?vue&type=style&index=0&id=c35a99d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c35a99d0"]])

export default __exports__